<template>
  <div class="border card-content-hover shadow shadow-sm">
    <div class="content  p-3">
      <img class="w-100 text-center img-content" :src="image" :alt="alt">
      <slot/>
    </div>
  </div>
</template>


<script>
export default {
  name: "C802",
  props: {
    image: {
      default: 'https://picsum.photos/1280/720'
    },
    alt: {
      default: 'mix it web'
    },
  }
};
</script>


<style scoped>
.img-content {
  transition: .2s ease-in-out all;
  object-fit: cover;
  height: 200px;
  width: 200px;
}

.card-content-hover {
  transition: .2s ease-in-out all;
}

.card-content-hover:hover {
  transition: .2s ease-in-out all;
  padding: 25px 0;
  box-shadow: 3px 5px 52px -5px rgba(0, 0, 0, 0.61) !important;
  -webkit-box-shadow: 3px 5px 52px -5px rgba(0, 0, 0, 0.61) !important;
  -moz-box-shadow: 3px 5px 52px -5px rgba(0, 0, 0, 0.61) !important;
}
</style>
